enum AuthenticationActionNames {
  TOKEN_CREATE = 'tokenCreate',
  TOKEN_REFRESH = 'tokenRefresh',
}

export default AuthenticationActionNames;
